/**
 * Coarse device-class hash used by the backend for per-class calibration.
 *
 * Goal: distinguish "iPhone 12-ish" from "Samsung mid-2024 Android" so the
 * aggregator can normalise g-readings. Goal NOT: device fingerprint.
 *
 * We use the userAgent's OS+major-version + screen size bucket. No
 * navigator.userAgentData hi-entropy probe.
 */
export function deviceClass(): string {
  const ua = navigator.userAgent;
  let os = 'unknown';
  if (/iPhone|iPad|iPod/.test(ua)) {
    const m = ua.match(/OS (\d+)_/);
    os = `ios-${m?.[1] ?? 'x'}`;
  } else if (/Android/.test(ua)) {
    const m = ua.match(/Android (\d+)/);
    os = `android-${m?.[1] ?? 'x'}`;
  } else {
    os = 'desktop';
  }
  const w = window.screen.width;
  const sizeBucket = w < 400 ? 'sm' : w < 700 ? 'md' : 'lg';
  return `${os}-${sizeBucket}`;
}
